import React, { useState } from 'react';
import { resolveConfigValue } from '../../state/index.js';
import { SUB_KEY_OPTIONS, TIER_LABEL, formatValue } from './constants.js';

// Demonstrates DC → Design → Category → Global → factory resolution against the
// live config. Category is DERIVED from the design code's first character
// (structural fact, CLAUDE.md §4) — no lookup table.
export default function ResolutionTester({ parameters, configValues }) {
  const [designId, setDesignId] = useState('');
  const [dcId, setDcId] = useState('');
  const [paramId, setParamId] = useState(parameters[0]?.id || '');
  const [status, setStatus] = useState('Y');

  const param = parameters.find((p) => p.id === paramId);
  const subKeys = param ? SUB_KEY_OPTIONS[param.id] : null;
  const derivedCategory = (designId || dcId || '').trim().charAt(0).toUpperCase() || null;

  let result = null;
  if (param) {
    const scope = {
      dc: dcId.trim() || undefined,
      design: designId.trim() || undefined,
      category: derivedCategory || undefined,
    };
    const subKey = subKeys ? status : undefined;
    result = resolveConfigValue(param, configValues, scope, subKey);
  }

  return (
    <div className="panel resolver">
      <h2>Resolution tester</h2>
      <p className="muted small">
        Enter a DC and/or design id; category is derived from the first letter of the design code.
        Resolution walks DC → Design → Category → Global → factory default.
      </p>
      <div className="resolver-inputs">
        <label className="field">
          <span className="field-label">design id</span>
          <input type="text" placeholder="F8152" value={designId} onChange={(e) => setDesignId(e.target.value)} />
        </label>
        <label className="field">
          <span className="field-label">dc id</span>
          <input type="text" placeholder="F013519-Violet" value={dcId} onChange={(e) => setDcId(e.target.value)} />
        </label>
        <label className="field">
          <span className="field-label">category (derived)</span>
          <input type="text" value={derivedCategory || ''} readOnly className="readonly" />
        </label>
        <label className="field">
          <span className="field-label">parameter</span>
          <select value={paramId} onChange={(e) => setParamId(e.target.value)}>
            {parameters.map((p) => (
              <option key={p.id} value={p.id}>{p.id} — {p.name}</option>
            ))}
          </select>
        </label>
        {subKeys && (
          <label className="field">
            <span className="field-label">status</span>
            <select value={status} onChange={(e) => setStatus(e.target.value)}>
              {subKeys.map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </label>
        )}
      </div>
      {result && (
        <div className="resolver-result">
          <div className="resolver-value">{formatValue(result.value)}</div>
          <div className="resolver-source">
            resolved from <strong>{TIER_LABEL[result.source] || result.source}</strong>
            {result.row && result.row.scope_key ? ` (${result.row.scope_key})` : ''}
          </div>
        </div>
      )}
    </div>
  );
}
